import { render, staticRenderFns } from "./sidebarTransfer.vue?vue&type=template&id=063cea10&"
import script from "./sidebarTransfer.vue?vue&type=script&lang=js&"
export * from "./sidebarTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports